module.exports = __webpack_public_path__ + "img/stock15.3d296971.png";